import { Component, EventEmitter, Input, OnChanges, OnInit, Output, } from "@angular/core";
import { FormGroup,  FormBuilder, Validators, FormArray } from "@angular/forms";
import { AdminService } from "../../../../services/admin.service";
import { apiUrl } from "../../../../global/global";
import { ToastrService } from "ngx-toastr";
import * as CONSTANT from "../../../../services/constants";
import { HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-step-one",
  templateUrl: "./step-one.component.html",
  styleUrls: ["./step-one.component.css"]
})
export class StepOneComponent implements OnInit, OnChanges {
  isStepper : number = 1;
  isSteps;
  @Input() filledData: any;
  @Input() isAdd: any;
  @Output() valueChange = new EventEmitter();
  @Output() stepperChange = new EventEmitter();
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  // form
  form: FormGroup;
  showErrorMin: boolean = false;
  showError: boolean = false;
  showLocation: boolean = false;
  showAddLocation: boolean = false;
  allCat:any=[];
  allindus:any=[];
  skillList:any=[];
  addedSkills:any=[];
  allEmployee:any=[];
  allSchedules:any=[];
  
  selectedIndustry = "";
  // job titles
  show = true;
  jobList:any=[];  
  allJobTitles:any=[];  
  userJobTitle: string = "";
  userJobTitleUpdate = new Subject<string>();
  addedJobs:any=[];
  // get sub-category
  categoryId:any;
  allSubCat:any=[];
  subCat:boolean=false;
  dropdownSettings:any;
  selectedGroup:any = [];
  filledSubCatData = false;
  allJobs;
  arrayUrl:any=[];
  constructor( private formBuilder: FormBuilder, private api: AdminService, private toastrService: ToastrService,private route: ActivatedRoute, private router: Router) {
    this.form = this.formBuilder.group({  
      id: [""],
      jobTitle: ["", Validators.compose([Validators.required,Validators.minLength(2),Validators.maxLength(50)])],
      categoryId: ["", Validators.compose([Validators.required])],
      industryId: ["", Validators.compose([Validators.required])],
      description: ["", Validators.compose([Validators.required,Validators.maxLength(1000)])],
      workPlaceLocation: ["", Validators.compose([Validators.required])],
      address: formBuilder.array([]),
      skillIds: ["", Validators.compose([Validators.required])],
      employementTypeId: [""],
      scheduleId: [""],
      subCategoryId: [""],
      // second
      payOption: [""],
      minimum: [""],
      maximum: [""],
      price: [""],
      rate: [""],
      benefitsIds: [""],
      supplementalPayId: [""],
      // third & four
      addCustomQuestion: [],
      // five 
      jobEligibleForId: [""],
      vaccinationCerificate: [""],
      quicklyNeedForHireId: [""],
      travelRequirementId: [""],
      noOfPeopleRequired: [""],
      personalitiesIds: [""],
      countryCode: [""],
      phoneNumber: [""],
      emailsIds: [],
      isConfirm: [""],
      steps: [""]
    })
   }
// add new address
newAddress() : FormGroup {
  return this.formBuilder.group({
    location : "",
    state : "",
    city: "",
    zipCode: "",
    latitude:"",
    longitude:"",
  })
}

getAddresses() {
  return (this.form.get('address') as FormArray).controls;
}
// host list
addMoreAddress(i){ 
  if((this.form.get('address') as FormArray).controls[i].value.location != ""){
  (this.form.controls['address'] as FormArray).push(this.newAddress()) }
}
deleteAdress(i){
  (this.form.controls['address'] as FormArray).removeAt(i);
}
  ngOnChanges(filledData: any) {
    if(filledData != undefined && filledData?.filledData?.currentValue != undefined){
      this.filledData = filledData.filledData.currentValue;
      this.allJobs =this.filledData;
      this.getSkillsFromFilledData(); 
      this.getJobFilledData();   
      this.getSelectedEmpType();
      this.getSelectedSchedule();
      this.getSelectedSubCategory();
      let address:FormArray = this.formBuilder.array([]);
      if(this.filledData?.address.length>0){
        (this.form.controls['address'] as FormArray).clear();
      } 
      this.filledData?.address?.map((addr)=>{
        address.push(this.formBuilder.group({
          location:addr.location,state:addr.state,city:addr.city,zipCode:addr.zipCode,latitude:addr.latitude,longitude:addr.longitude
        }))
      }) 
      if(this.filledData?.address == null || this.filledData?.address == ""){
        address.push(this.formBuilder.group({
          location:this.filledData?.JobPost?.location

        }))
      }
      this.categoryId = this.filledData?.JobPost?.categoryId
      this.subCat=true;
      this.getSubCat();
       
      let skillid:any=[];
      this.filledData?.JobPostSkills?.map((skill)=>{
        skillid.push({skillId:skill.skillId})
      })
      let supplementalPayid:any=[];
      this.filledData?.supplementalPay?.map((pay)=>{
        supplementalPayid.push({supplementalPayId:pay.supplementalPayId})
      })
      let benefitsid:any=[];
      this.filledData?.JobPostBenefits?.map((beni)=>{
        benefitsid.push({benefitsId:beni.benefitsId})
      })
      let personalitiesid:any=[];
      this.filledData?.JobPostPersonalities?.map((per)=>{
        personalitiesid.push({personalitiesId:per.personalitiesId})
      })
      let jobEligibleForid:any=[];
      this.filledData?.jobEligibleFor?.map((elg)=>{
        jobEligibleForid.push({jobEligibleForId:elg.jobEligibleForId})
      })
      let emailid:any=[];
      this.filledData?.JobPostNotificationEmails?.map((email)=>{
        emailid.push({emailId:email.emailId})
      })
      let subCategoryIds:any=[];
      this.filledData?.subCategory?.map((subCat)=>{
        subCategoryIds.push({categoryId:subCat.categoryId,subCategoryId:subCat.subCategoryId})
      })
      let addQuestion:any=[];
      this.filledData?.JobPostAddQuestions?.map((question)=>{
        addQuestion.push({addScreeningQuestionId:question.addScreeningQuestionId,title:question.title,experience:question.experience,responseType:question.responseType,answer:question.answer})
      }) 
      this.form.patchValue({
        ...this.filledData?.JobPost,
        jobTitle:this.filledData?.JobPost?.jobTitle,
        categoryId:this.filledData?.JobPost?.categoryId,
        industryId:this.filledData?.JobPost?.industryId,
        description:this.filledData?.JobPost?.description,
        workPlaceLocation:this.filledData?.JobPost?.workPlaceLocation,
        // location:this.filledData?.JobPost?.location,
        employementTypeId:this.filledData?.JobPost?.employementTypeId,
        scheduleId:this.filledData?.JobPost?.scheduleId,
        payOption:this.filledData?.JobPost?.payOption,
        minimum:this.filledData?.JobPost?.minimum,
        maximum:this.filledData?.JobPost?.maximum,
        price:this.filledData?.JobPost?.price,
        rate:this.filledData?.JobPost?.rate,
        steps:this.filledData?.JobPost?.steps,
        vaccinationCerificate:this.filledData?.JobPost?.vaccinationCerificate.toString(),
        quicklyNeedForHireId:this.filledData?.JobPost?.quicklyNeedForHireId,
        travelRequirementId:this.filledData?.JobPost?.travelRequirementId,
        noOfPeopleRequired:this.filledData?.JobPost?.noOfPeopleRequired,
        countryCode:this.filledData?.JobPost?.countryCode,
        phoneNumber:this.filledData?.JobPost?.phoneNumber,
        skillIds:skillid,
        subCategoryId:subCategoryIds,
        supplementalPayId:supplementalPayid,
        benefitsIds:benefitsid,
        personalitiesIds:personalitiesid,
        jobEligibleForId:jobEligibleForid,
        emailsIds:emailid,
        addCustomQuestion:addQuestion,
        // address:address,
        isConfirm:0
      })
      this.form.setControl("address", address) 
      if(this.filledData != undefined && this.filledData?.JobPost?.workPlaceLocation  != "Remote"){
        this.showLocation = true;
        this.showAddLocation = true;
      } else{
        this.showLocation= false
        this.showAddLocation= false
      }
    }
  } 
 
  getJobFilledData() {
    if (this.filledData != undefined && this.jobList.length > 0) {
      let jobTitles = this.jobList;
      this.jobList = []; 
      jobTitles.map((job) => {
          if (job.name == this.filledData?.JobPost?.jobTitle) {
            this.form.patchValue({
              jobTitle: job.name
            })
          }
      }) 

      if (this.form.value.jobTitle == "") {
        jobTitles.push({name: this.filledData?.JobPost?.jobTitle})
        this.form.patchValue({
          jobTitle: this.filledData?.JobPost?.jobTitle
        })
      }
    }
  }
  getSkillsFromFilledData() {
    if (this.filledData != undefined && this.skillList.length > 0) {
      let allJobTitles = this.skillList;
      this.skillList = [];
      this.addedSkills = [];
      allJobTitles.map((skill) => {
        let alreadyAdded = false;
        this.filledData.JobPostSkills.map((addedSkill) => {
          if (skill.id == addedSkill.skillId) {
            alreadyAdded = true;
          }
        })
        if (alreadyAdded) {
          this.addedSkills.push(skill);
        } else {
          this.skillList.push(skill);
        }
      }) 
    }
  }

  getSelectedEmpType() {
    if (this.allEmployee.length > 0 && this.filledData != undefined){
    this.allEmployee.map((emp)=> {
      if(emp.id == this.filledData.JobPost.employementTypeId) {
        emp['selected'] = true;
      }
    })
  }
  }
  getSelectedSchedule() {
    if (this.allSchedules.length > 0 && this.filledData != undefined){
    this.allSchedules.map((sch)=> {
      if(sch.id == this.filledData.JobPost.scheduleId) {
        sch['selected'] = true;
      }
    })
  }
  } 
  getSelectedSubCategory() {
    if (this.filledData?.subCategory != undefined && this.allSubCat.length > 0) {
      this.allSubCat.map((subcat) => { 
        this.filledData?.subCategory.map((addedCat) => {
          if (this.allSubCat.id == addedCat.id) {
            this.subCat = true;
            this.form.patchValue({
              subCategoryId :this.filledData?.subCategory
            })
          }
        }) 
      }) 
    }
  } 

  ngOnInit(): void {
    this.arrayUrl = this.router.url.split("/")
    if(this.filledData== undefined || this.filledData?.address.length == 0){
      (this.form.controls['address'] as FormArray).push(this.newAddress()) ;
    }
    this.getCat();
    this.getSubCat();
    this.getIndus();
    this.getSkills();
    this.getEmpType();
    this.getSchedules();
    this.userJobTitleUpdate.pipe(
      debounceTime(10),
      distinctUntilChanged())
      .subscribe(value => {
        if(value == ""){
          this.jobList = [];
          this.show=false;
        } else{
          let params = new HttpParams(); 
        params = params.append("search", value);
        this.api.showLoader=false;
        this.api.loader(false)
        this.api.getData(apiUrl._searchJobTitle,params)
              .subscribe(async (res) => {
                console.log(res,'_searchJobTitle');
                
                this.jobList = [];
                res.data.jobTitle.map((skill) => {
                  let alreadyAdded = false;
                  this.addedJobs.map((addedJobs)=> {
                    if (addedJobs.id == skill.id) {
                      alreadyAdded = true;
                    }
                  })
                  if (!alreadyAdded) {
                    this.jobList.push(skill);
                  }
                  this.show=true;
                })
          })
        }
      });
    this.getJobTitle();
    
    this.dropdownSettings = {
			singleSelection: false,
			idField: "id",
			textField: "name",
			itemsShowLimit: 2,
			allowSearchFilter: true,
      unSelectAllText: "Unselect All",
		};
  } 
  
  search() {
    this.userJobTitleUpdate.next(this.userJobTitle)
  }
  drop(){
    this.show=false;
  }
  selectedJobs(i){
    this.addedJobs.push(this.jobList[i])
    this.form.patchValue({
      jobTitle: this.jobList[i].name
    })
  }
  removeJobs(i){
    this.addedJobs.splice(i,1)
  }
  // category
  getJobTitle(){
  this.api.stopLoader(); 
    this.api.getDatas(apiUrl._searchJobTitle)
    .subscribe(async (res) => {
      this.jobList = res.data.jobTitle; 
      this.getJobFilledData(); 

     })
  } 
  // selecte location
  selectedLocation(event){
      if(event  != "Remote"){
        this.showLocation = true;
        this.showAddLocation = true;
      } else{
        this.showLocation= false;
        this.showAddLocation = false;
      }
  }
  // category
  getCat(){
  this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getCategories)
    .subscribe(async (res) => {
      this.allCat = res.data.data;
     })
  } 
  selectCategoryId(event){
    this.categoryId =event.target.value
    this.subCat=true; 
    this.allSubCat = []
    this.form.patchValue({
      subCategoryId :[]
    })
    this.getSubCat()
  }
  // sub-category
  getSubCat(){
  this.api.stopLoader(); 
    let params = new HttpParams(); 
    params = params.append("categoryId", this.categoryId);
    this.api.getData(apiUrl._getSubCategories,params)
    .subscribe(async (res) => { 
      this.allSubCat = []
      if(res.data.count > 0){
        this.allSubCat = res.data.data;
      } else{
        this.allSubCat = []
        this.form.patchValue({
          subCategoryId :[]
        })
      }

      if (this.filledData != undefined && !this.filledSubCatData) {
        this.filledSubCatData = true
        if (this.filledData.subCategory.length > 0) {
          let selectedSubCats : any = []
          this.filledData.subCategory.map((subcats) => {
            selectedSubCats.push({"id": subcats.subCategoryId, "name": subcats.subCategoryName})
          })
          this.form.patchValue({
            subCategoryId :selectedSubCats
          })
        } else {
          let selectedSubCats : any = []
          this.form.patchValue({
            subCategoryId :selectedSubCats
          })
        }
      }
    })
  } 
    // ============ Multiple dropdown functionality =============
    onItemSelect(item: any) {}
    onItemDeSelect(item: any) {}
    onDeSelectAll(item:any) {
      this.form.patchValue({
        subCategoryId: []
      })
    }
    onSelectAll(items: any) {
      let data:any = []
      for (let i = 0; i < items.length; i++) {
        data.push(items[i])
      }
      this.form.patchValue({
        subCategoryId: data
      })
      console.log(this.form,'this.form');
      
    }
  // getIndus
  getIndus(){
  this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getIndus)
    .subscribe(async (res) => {
      this.allindus = res.data.data;
     })
  } 
  // selected Skill
  selectedSkill(event){
    if (event.target.value == 0) return;
    this.addedSkills.push(this.skillList[event.target.value]);
    this.skillList.splice(event.target.value,1);
  }
   // remove Skill
  removeSkills(i){
    this.addedSkills.splice(i,1)
  }
   // Skill
  getSkills(){
  this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getSkills)
    .subscribe(async (res) => { 
      this.skillList = res.data.listing; 
      this.skillList.splice(0, 0, {name: "Enter"});
      this.getSkillsFromFilledData();
      })
  }
  // employee
  getEmpType(){
  this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getEmploymentTypes)
    .subscribe(async (res) => {
      this.allEmployee = res.data.listing;
      this.getSelectedEmpType();
     })
  } 
  // selected employee
  selectedEmployment(i,event){ 
    this.allEmployee.map((emp)=>{
      emp["selected"] = false;
    })
    this.allEmployee[i]["selected"] = true;
  }
  // schedules
  getSchedules(){
  this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getSchedules)
    .subscribe(async (res) => {
      this.allSchedules = res.data.data;
      this.getSelectedSchedule();
     })
  } 
  // selected employee
  selectedSchedules(i,event){ 
    this.allSchedules.map((sch)=>{
      sch["selected"] = false;
    })
    this.allSchedules[i]["selected"] = true;
  } 
// on form submit
  onSubmit(){
    if(this.showLocation){
      let anyAddressEmpty = false;
      this.getAddresses().map((add) => {
        if (add.value.location == "") {
          anyAddressEmpty = true;
         
        }
      })
      if (anyAddressEmpty) {
        this.showError= true;
        setTimeout(() => {
          this.showError=false
        }, 1000);
        return
      } else {
        this.showError=false
      }
      
    } else{
      this.showError=false
    }
    if(this.form.value.jobTitle.length < 2){
      this.showErrorMin = true;
      setTimeout(() => {
        this.showErrorMin = false;
      }, 2000);
    }
    let skillIds:any=[];
    this.addedSkills.map((skill)=>{
      skillIds.push({"skillId":skill.id})
    })
    let employeeType = ""
    this.allEmployee.map((employee) => {
      if(employee["selected"] == true) {
        if (employeeType == "") {
          employeeType = employee.id
        } else {
          employeeType = employeeType + "," + employee.id
        }
      }
    })
    let schedule = ""
    this.allSchedules.map((sche) => {
      if(sche["selected"] == true) {
        if (schedule == "") {
          schedule = sche.id
        } else {
          schedule = schedule + "," + sche.id
        }
      }
    })
    let emptyAddreddPos : any = []
    for (let i=0; i< this.form.value.address.length; i++){
      if (this.form.value.address[i]["location"] == "") {
        emptyAddreddPos.push(i);
      }
    }
    emptyAddreddPos.map((pos) => {
      this.deleteAdress(pos);
    })
    
    this.form.patchValue({
      skillIds:skillIds,
      employementTypeId:employeeType,
      scheduleId:schedule
    }) 

    if (this.isAdd) {
      this.form.patchValue({
        steps: 1
      }) 
    }
    
    if(this.form.valid){
      let subCategory:any=[];
      this.form.value.subCategoryId.map((subcat)=>{
        subCategory.push({"categoryId":this.categoryId,"subCategoryId":subcat.id}); 
      })

      this.form.patchValue({
        subCategoryId:subCategory
      })
      

      if(this.filledData?.JobPost?.id){
        this.api.putData(apiUrl._getJobs, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => { 
          this.valueChange.emit({ data: res.data.result.payload });
        })
      } else{
          delete this.form.value.id
        this.api.postData(apiUrl._addJobs, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => {
          this.valueChange.emit({ data: res.data.result.add });
        })
      }
    } else{
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 2000);
    }
  }
  
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }
  
    return formValues
  }
}
